export default __webpack_public_path__ + "static/media/GoldPlatedAcrylicOdishaPolaBangles.f2ad7a08.jpg";